import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {AddPage as AddOrderPage} from '../orders/pages/AddPage';
import {EditPage as OrderEditPage} from '../orders/pages/EditPage';
import {AddPage as AddSubscriptionPage} from '../customer-subscriptions/pages/AddPage';
import {EditPage as SubscriptionEditPage} from '../customer-subscriptions/pages/EditPage';
import {AddPage as AddSubscriptionItemPage} from '../subscription-items/pages/AddPage';
import {AddPage as AddInvoicePage} from '../invoices/pages/AddPage';
import {EditPage as InvoiceEditPage} from '../invoices/pages/EditPage';
import {AddPage as AddMeteringRecordPage} from '../metering-records/pages/AddPage';
import {rbacActions} from "../../config/rbac/actions.ts";
import {RestrictedRouteElement} from "../../components/RestrictedRouteElement.tsx";


export const CustomersLayout = () => {


    return (
        <Routes>

            <Route
                path='/'
                element={<RestrictedRouteElement rbacAction={rbacActions.ListCustomers}>
                    <IndexPage/></RestrictedRouteElement>}
            />
            <Route
                path='add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreateCustomer}>
                    <AddPage/></RestrictedRouteElement>}
            />
            <Route
                path=':id'
                element={<RestrictedRouteElement rbacAction={rbacActions.GetCustomer}>
                    <EditPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/orders/add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreateOrder}>
                    <AddOrderPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/orders/:orderId'
                element={<RestrictedRouteElement rbacAction={rbacActions.GetOrder}>
                    <OrderEditPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/subscriptions/add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreateSubscription}>
                    <AddSubscriptionPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/subscriptions/:subscriptionId'
                element={<RestrictedRouteElement rbacAction={rbacActions.GetSubscription}>
                    <SubscriptionEditPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/subscriptions/:subscriptionId/subscription-items/add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreateSubscriptionItem}>
                    <AddSubscriptionItemPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/invoices/add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreateInvoice}>
                    <AddInvoicePage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/invoices/:invoiceId'
                element={<RestrictedRouteElement rbacAction={rbacActions.GetInvoice}>
                    <InvoiceEditPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/metering-records/add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreateMeteringRecord}>
                    <AddMeteringRecordPage/></RestrictedRouteElement>}
            />

        </Routes>
    );
};
